import { type AggregatedMetrics } from '@prerender/prerender-shared/FE';

import { readDomainParam } from '~components/Filters/domainParam';
import { type DashboardV3SavedFilters } from './DashboardV3SavedFilters';

const STORAGE_KEY = '/dashboard-v3/filters';

export type DashboardV3StoredFilters = Partial<
  AggregatedMetrics.BaseGraphQueryParams & {
    includeScheduledRenders?: boolean;
  }
>;

function getLocalStorageKey(userId: number) {
  return `${userId}${STORAGE_KEY}`;
}

export function saveFilters(filters: DashboardV3SavedFilters, userId: number) {
  const localStorageKey = getLocalStorageKey(userId);

  const existingFilters = loadFilters(userId);
  if (existingFilters) {
    const updatedFilters = Object.assign(existingFilters, filters);
    sessionStorage.setItem(localStorageKey, JSON.stringify(updatedFilters));
  } else {
    sessionStorage.setItem(localStorageKey, JSON.stringify(filters));
  }
}

export function loadFilters(userId: number): DashboardV3SavedFilters | null {
  const localStorageKey = getLocalStorageKey(userId);
  const filters = sessionStorage.getItem(localStorageKey);
  if (!filters) return null;

  try {
    const parsedFilters = JSON.parse(filters);
    if (parsedFilters.dateFrom) parsedFilters.dateFrom = new Date(parsedFilters.dateFrom);
    if (parsedFilters.dateTo) parsedFilters.dateTo = new Date(parsedFilters.dateTo);
    parsedFilters.domain = readDomainParam(parsedFilters.domain);
    if ('hideScheduledRenders' in parsedFilters && !('includeScheduledRenders' in parsedFilters)) {
      parsedFilters.includeScheduledRenders = !parsedFilters.hideScheduledRenders;
      delete parsedFilters.hideScheduledRenders;
    }
    return parsedFilters;
  } catch {
    return null;
  }
}
